var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useContext } from "react";
import { ThemeModeContext } from "../context/theme-mode-context";
import createPersistedState from 'use-persisted-state';
import { useThemeEval } from "./use-theme-eval";
import { isDarkColor } from "@shapeable/utils";
import { COLOR } from "@shapeable/theme";
var usePersistedState = createPersistedState('theme-mode');
export var useThemeMode = function () {
  var contextMode = useContext(ThemeModeContext);
  var _a = __read(usePersistedState(contextMode), 1),
    mode = _a[0];
  return contextMode || mode || 'light';
};
export var useThemeModeForBg = function (bgColor) {
  var $ = useThemeEval();
  // if the bgColor is falsy (e.g. suppose it comes from a prop or entity field)
  if (!bgColor) {
    return 'auto';
  }
  var themeColor = $(COLOR(bgColor));
  var isDark = false;
  try {
    isDark = isDarkColor(themeColor);
    return isDarkColor(themeColor) ? 'dark' : 'light';
  } catch (e) {
    return 'auto';
  }
};